import React from "react";

export const Copyright = () => {
  return (
    <footer className="bg-gray-900 text-center py-4 shadow-lg">
      <p className="text-white text-sm">
        © 2023 Portfolio of Humaion kobir . All rights reserved 
      </p>
    </footer>
  );
};

